import { PAGE_TYPES } from '../shared/utils/analytics/constants'

export const microPrefix = 'nol-portal-games'

export function getPageType(slug) {
	if (slug === '/magazin/juegos/') return PAGE_TYPES.GENERIC

	return PAGE_TYPES.GENERIC
}
